import React from 'react'
import { Box } from '@chakra-ui/react'

import { Container, Layout } from '../components/layout'
import notFound from '../images/not-found.svg'

const NotFoundPage = () => (
  <Layout>
    <Container>
      <Box sx={{ py: 4 }}>
        <h1>NOT FOUND</h1>

        <p>
          The page you are looking for doesn&#39;t exist... Please use the links
          above to navigate to the page you want.
        </p>
        <br />
        <Box style={{ px: [3, 4, 5], py: [2, 3], width: 'full' }}>
          <img src={notFound} alt="Not Found" width="100%" />
        </Box>
      </Box>
    </Container>
  </Layout>
)

export default NotFoundPage
